import { render, staticRenderFns } from "./SurveyScoreTable.vue?vue&type=template&id=370d8ef4&"
import script from "./SurveyScoreTable.vue?vue&type=script&lang=js&"
export * from "./SurveyScoreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports